import './styles.scss';
import DATA from 'utils/data.json';
import { useState } from 'react';
import ARROW_LEFT from 'assets/images/icon-arrow-left.svg';
import ARROW_RIGHT from 'assets/images/icon-arrow-right.svg';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import useMediaQuery from 'hooks/useMediaQuery';

const TEACHER_DATA = DATA.teacher;
const ADVISERS_DATA = TEACHER_DATA.advisers

const Advisers = () => {
    const [controlledSwiper, setControlledSwiper] = useState(null);
    const [selectingIndex, setSelectingIndex] = useState(0);
    const isMobile = useMediaQuery('(max-width: 768px)');

    const onPrev = () => {
        controlledSwiper.slidePrev()
        setSelectingIndex(controlledSwiper.realIndex)
    }

    const onNext = () => {
        controlledSwiper.slideNext()
        setSelectingIndex(controlledSwiper.realIndex)
    }

    return (
        <div className="advisers-block">
            <div className='left'>
                <p className="title container">{TEACHER_DATA.title}</p>
                <div className='title-wrapper container'>
                    <img src={ADVISERS_DATA.icon} className="icon" alt='' />
                    <p>{ADVISERS_DATA.title}</p>
                </div>
                <div className='content container'>
                    <div className='info'>
                        <p className='name'>{ADVISERS_DATA.list[selectingIndex].name}</p>
                        <p className='position'>{ADVISERS_DATA.list[selectingIndex].position}</p>
                        <p className='desc'>{ADVISERS_DATA.list[selectingIndex].desc}</p>
                    </div>

                    <div className='arrow'>
                        <button onClick={onPrev}>
                            <img alt='' src={ARROW_LEFT} className='icon-arrow' />
                        </button>
                        <button onClick={onNext}>
                            <img alt='' src={ARROW_RIGHT} className='icon-arrow' />
                        </button>
                    </div>
                </div>
            </div>
            <div className='right'>
                <div className='overlay'/>
                <Swiper
                    slidesPerView={isMobile ? 1 : 2}
                    loop={true}
                    slideToClickedSlide={true}
                    onSwiper={setControlledSwiper}
                    onSlideChange={() => setSelectingIndex(controlledSwiper?.realIndex || 0)}
                    style={{ paddingBottom: 10 }}
                >
                    {ADVISERS_DATA.list.map((item, index) => {
                        return (
                            <SwiperSlide key={index} onClick={() => setSelectingIndex(index)}>
                                <div className={`item ${selectingIndex === index ? 'active' : ''}`}>
                                    <div className='image-wrapper'>
                                        <img src={item.image} alt='' className='image' />
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </div>
    )
}

export default Advisers